import { useQuery } from "@tanstack/react-query";
import { ApiAuth } from "../../../lib/api";
import { plansApi } from "./api";

export const PLANS_KEY = "patient-plans";

export function usePlans(auth: ApiAuth, enabled = true) {
  return useQuery({
    queryKey: [PLANS_KEY],
    queryFn: () => plansApi.get(auth),
    enabled,
    staleTime: 60_000,
  });
}
